import InputMoney from "./money";

export default InputMoney;
